import React from 'react';

export type IconProps = {
  fillColor: string;
  height: number;
  width: number;
};

export function ExternalLinkIcon({ fill }: { fill?: string }) {
  return (
    <svg
      aria-hidden='true'
      xmlns='http://www.w3.org/2000/svg'
      width='17'
      height='16'
      fill='none'
      viewBox='0 0 17 16'
    >
      <path
        fill={fill}
        d='M16.031 0l-5.093.031A.427.427 0 0010.5.47V1.5c0 .25.188.469.438.469l2.312-.094.063.063-8.72 8.718c-.062.063-.124.156-.124.25 0 .125.062.219.125.281l.718.72a.396.396 0 00.282.124c.093 0 .187-.062.25-.125l8.718-8.719.063.063-.094 2.313c0 .25.219.468.469.468V6h1.031c.25 0 .438-.188.438-.438L16.5.47A.48.48 0 0016.031 0zM14 9h-.5c-.281 0-.5.25-.5.5v4.813c0 .124-.094.187-.188.187H2.188c-.126 0-.188-.063-.188-.188V3.688c0-.094.063-.188.188-.188H7c.25 0 .5-.219.5-.5v-.5c0-.25-.25-.5-.5-.5H2A1.5 1.5 0 00.5 3.5v11c0 .844.656 1.5 1.5 1.5h11a1.5 1.5 0 001.5-1.5v-5c0-.25-.25-.5-.5-.5z'
      />
    </svg>
  );
}

export function ListIcon() {
  return (
    <svg
      aria-hidden='true'
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      fill='none'
      viewBox='0 0 16 16'
    >
      <path
        fill='#fff'
        d='M4.438 9.469l2-2a.151.151 0 000-.219l-.407-.406a.151.151 0 00-.218 0l-1.5 1.468-.625-.656c-.094-.062-.188-.062-.25 0l-.407.407a.151.151 0 000 .218L4.187 9.47a.19.19 0 00.25 0zM11 2.5H8.5c0-1.094-.906-2-2-2-1.125 0-2 .906-2 2H2A1.5 1.5 0 00.5 4v11c0 .844.656 1.5 1.5 1.5h9a1.5 1.5 0 001.5-1.5V4c0-.813-.688-1.5-1.5-1.5zM6.5 2c.25 0 .5.25.5.5 0 .281-.25.5-.5.5a.494.494 0 01-.5-.5c0-.25.219-.5.5-.5zM11 14.75c0 .156-.125.25-.25.25h-8.5c-.156 0-.25-.094-.25-.25V4.25c0-.125.094-.25.25-.25H3.5v1c0 .281.219.5.5.5h5c.25 0 .5-.219.5-.5V4h1.25c.125 0 .25.125.25.25v10.5zm-7-4a.74.74 0 00-.75.75c0 .438.313.75.75.75a.74.74 0 00.75-.75.76.76 0 00-.75-.75zM9.25 8h-2l-.094.188L6.313 9H9.25c.125 0 .25-.094.25-.25v-.5A.269.269 0 009.25 8zm0 3h-3.5a.246.246 0 00-.25.25v.5c0 .156.094.25.25.25h3.5c.125 0 .25-.094.25-.25v-.5a.269.269 0 00-.25-.25z'
      />
    </svg>
  );
}

export function MapsMarker() {
  return (
    <svg
      aria-hidden='true'
      xmlns='http://www.w3.org/2000/svg'
      width='21.333'
      height='37.218'
      version='1.1'
      viewBox='0 0 20 34.892'
    >
      <g transform='translate(-814.596 -274.386)'>
        <g fillOpacity='1' transform='matrix(1.18559 0 0 1.18559 -151.177 -57.398)'>
          <path
            fill='#ff4646'
            stroke='#d73534'
            strokeDasharray='none'
            strokeMiterlimit='4'
            strokeOpacity='1'
            strokeWidth='1'
            d='M817.112 282.971c-1.258 1.343-2.046 3.299-2.015 5.139.064 3.845 1.797 5.3 4.568 10.592.999 2.328 2.04 4.792 3.031 8.873.138.602.272 1.16.335 1.21.062.048.196-.513.334-1.115.99-4.081 2.033-6.543 3.031-8.871 2.771-5.292 4.504-6.748 4.568-10.592.031-1.84-.759-3.798-2.017-5.14-1.437-1.535-3.605-2.67-5.916-2.717-2.312-.048-4.481 1.087-5.919 2.621z'
            display='inline'
            opacity='1'
          />
          <circle
            cx='823.031'
            cy='288.253'
            r='3.035'
            fill='#590000'
            strokeWidth='0'
            display='inline'
            opacity='1'
          />
        </g>
      </g>
    </svg>
  );
}

export function MapIcon() {
  return (
    <svg
      aria-hidden='true'
      role='img'
      xmlns='http://www.w3.org/2000/svg'
      width='22'
      height='20'
      viewBox='0 0 22 20'
      version='1.1'
    >
      <path
        fill='#000000'
        d='M 11 0 C 8.34375 0 6.1875 2.203125 6.1875 4.921875 C 6.1875 7.121094 9.332031 11.125 10.539062 12.578125 C 10.78125 12.875 11.21875 12.875 11.460938 12.578125 C 12.667969 11.125 15.8125 7.121094 15.8125 4.921875 C 15.8125 2.203125 13.65625 0 11 0 Z M 11 6.5625 C 10.113281 6.5625 9.394531 5.828125 9.394531 4.921875 C 9.394531 4.015625 10.113281 3.28125 11 3.28125 C 11.886719 3.28125 12.605469 4.015625 12.605469 4.921875 C 12.605469 5.828125 11.886719 6.5625 11 6.5625 Z M 0.769531 8.4375 C 0.304688 8.625 0 9.085938 0 9.597656 L 0 19.375 C 0 19.816406 0.4375 20.117188 0.839844 19.953125 L 6.109375 17.5 L 6.109375 8.394531 C 5.773438 7.769531 5.496094 7.164062 5.300781 6.582031 Z M 11 14.050781 C 10.460938 14.050781 9.953125 13.808594 9.605469 13.386719 C 8.855469 12.480469 8.054688 11.449219 7.332031 10.390625 L 7.332031 17.5 L 14.667969 20 L 14.667969 10.390625 C 13.945312 11.449219 13.144531 12.480469 12.394531 13.386719 C 12.046875 13.808594 11.539062 14.050781 11 14.050781 Z M 21.160156 6.296875 L 15.890625 8.75 L 15.890625 20 L 21.230469 17.8125 C 21.695312 17.625 22 17.164062 22 16.652344 L 22 6.875 C 22 6.433594 21.5625 6.132812 21.160156 6.296875 Z M 21.160156 6.296875 '
      />
    </svg>
  );
}

export function PdfIcon() {
  return (
    <svg
      aria-hidden='true'
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='24'
      fill='none'
      viewBox='0 0 18 24'
    >
      <path
        fill='#000'
        d='M17.297 4.594L13.407.656A2.315 2.315 0 0011.811 0H2.25A2.25 2.25 0 000 2.25v19.5C0 23.016.984 24 2.25 24h13.5A2.25 2.25 0 0018 21.75V6.187c0-.562-.281-1.171-.703-1.593zM15.562 6H12V2.437L15.563 6zM2.25 21.75V2.25h7.5v4.875c0 .656.469 1.125 1.125 1.125h4.875v13.5H2.25zm11.719-6.703c-.563-.563-2.203-.422-3.047-.328-.797-.469-1.313-1.172-1.688-2.156.141-.75.47-1.922.235-2.626-.188-1.218-1.781-1.124-2.016-.28-.187.75 0 1.827.328 3.14a50.542 50.542 0 01-1.64 3.515c-.938.47-2.204 1.22-2.391 2.157-.14.75 1.219 2.578 3.563-1.453 1.03-.375 2.203-.797 3.187-.985.89.516 1.922.797 2.625.797 1.219 0 1.313-1.312.844-1.781zm-9.281 3.656c.234-.656 1.125-1.406 1.406-1.64-.89 1.406-1.407 1.64-1.407 1.64zM8.483 9.75c.375 0 .329 1.5.094 1.922-.187-.656-.187-1.922-.094-1.922zM7.36 16.172c.47-.797.844-1.735 1.172-2.578.375.703.844 1.265 1.406 1.64-.984.235-1.828.61-2.578.938zm6.141-.235s-.234.282-1.734-.374c1.64-.141 1.921.234 1.734.374z'
      />
    </svg>
  );
}

export function DownloadIcon() {
  return (
    <svg
      aria-hidden='true'
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      fill='none'
      viewBox='0 0 16 16'
    >
      <path
        fill='#000'
        d='M6.75 0A.74.74 0 006 .75V6H3.25c-.563 0-.844.688-.438 1.094l4.75 4.75a.625.625 0 00.844 0l4.75-4.75C13.562 6.687 13.281 6 12.72 6H10V.75A.76.76 0 009.25 0h-2.5zM16 11.75a.76.76 0 00-.75-.75h-4.594l-1.531 1.531a1.568 1.568 0 01-2.281 0L5.312 11H.75a.74.74 0 00-.75.75v3.5c0 .438.313.75.75.75h14.5a.74.74 0 00.75-.75v-3.5zm-3.875 2.75a.627.627 0 01-.625.625.627.627 0 01-.625-.625c0-.344.281-.625.625-.625s.625.281.625.625zm2 0a.627.627 0 01-.625.625.627.627 0 01-.625-.625c0-.344.281-.625.625-.625s.625.281.625.625z'
      />
    </svg>
  );
}

export function MobileMenuIcon() {
  return (
    <svg
      aria-hidden='true'
      role='img'
      xmlns='http://www.w3.org/2000/svg'
      width='36'
      height='36'
      viewBox='0 0 36 36'
      version='1.1'
    >
      <path
        fill='#ffffff'
        d='M 5.625 25.875 L 1.125 25.875 C 0.503906 25.875 0 26.378906 0 27 L 0 31.5 C 0 32.121094 0.503906 32.625 1.125 32.625 L 5.625 32.625 C 6.246094 32.625 6.75 32.121094 6.75 31.5 L 6.75 27 C 6.75 26.378906 6.246094 25.875 5.625 25.875 Z M 5.625 3.375 L 1.125 3.375 C 0.503906 3.375 0 3.878906 0 4.5 L 0 9 C 0 9.621094 0.503906 10.125 1.125 10.125 L 5.625 10.125 C 6.246094 10.125 6.75 9.621094 6.75 9 L 6.75 4.5 C 6.75 3.878906 6.246094 3.375 5.625 3.375 Z M 5.625 14.625 L 1.125 14.625 C 0.503906 14.625 0 15.128906 0 15.75 L 0 20.25 C 0 20.871094 0.503906 21.375 1.125 21.375 L 5.625 21.375 C 6.246094 21.375 6.75 20.871094 6.75 20.25 L 6.75 15.75 C 6.75 15.128906 6.246094 14.625 5.625 14.625 Z M 34.875 27 L 12.375 27 C 11.753906 27 11.25 27.503906 11.25 28.125 L 11.25 30.375 C 11.25 30.996094 11.753906 31.5 12.375 31.5 L 34.875 31.5 C 35.496094 31.5 36 30.996094 36 30.375 L 36 28.125 C 36 27.503906 35.496094 27 34.875 27 Z M 34.875 4.5 L 12.375 4.5 C 11.753906 4.5 11.25 5.003906 11.25 5.625 L 11.25 7.875 C 11.25 8.496094 11.753906 9 12.375 9 L 34.875 9 C 35.496094 9 36 8.496094 36 7.875 L 36 5.625 C 36 5.003906 35.496094 4.5 34.875 4.5 Z M 34.875 15.75 L 12.375 15.75 C 11.753906 15.75 11.25 16.253906 11.25 16.875 L 11.25 19.125 C 11.25 19.746094 11.753906 20.25 12.375 20.25 L 34.875 20.25 C 35.496094 20.25 36 19.746094 36 19.125 L 36 16.875 C 36 16.253906 35.496094 15.75 34.875 15.75 Z M 34.875 15.75 '
      />
    </svg>
  );
}

export function CloseIcon() {
  return (
    <svg
      aria-hidden='true'
      role='img'
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      version='1.1'
    >
      <path
        fill='#595959'
        d='M 10 0.3125 C 4.648438 0.3125 0.3125 4.648438 0.3125 10 C 0.3125 15.351562 4.648438 19.6875 10 19.6875 C 15.351562 19.6875 19.6875 15.351562 19.6875 10 C 19.6875 4.648438 15.351562 0.3125 10 0.3125 Z M 10 17.8125 C 5.683594 17.8125 2.1875 14.316406 2.1875 10 C 2.1875 5.683594 5.683594 2.1875 10 2.1875 C 14.316406 2.1875 17.8125 5.683594 17.8125 10 C 17.8125 14.316406 14.316406 17.8125 10 17.8125 Z M 13.976562 7.570312 L 11.546875 10 L 13.976562 12.429688 C 14.160156 12.613281 14.160156 12.910156 13.976562 13.09375 L 13.09375 13.976562 C 12.910156 14.160156 12.613281 14.160156 12.429688 13.976562 L 10 11.546875 L 7.570312 13.976562 C 7.386719 14.160156 7.089844 14.160156 6.90625 13.976562 L 6.023438 13.09375 C 5.839844 12.910156 5.839844 12.613281 6.023438 12.429688 L 8.453125 10 L 6.023438 7.570312 C 5.839844 7.386719 5.839844 7.089844 6.023438 6.90625 L 6.90625 6.023438 C 7.089844 5.839844 7.386719 5.839844 7.570312 6.023438 L 10 8.453125 L 12.429688 6.023438 C 12.613281 5.839844 12.910156 5.839844 13.09375 6.023438 L 13.976562 6.90625 C 14.160156 7.089844 14.160156 7.386719 13.976562 7.570312 Z M 13.976562 7.570312 '
      />
    </svg>
  );
}

export function ScholarshipIcon() {
  return (
    <svg
      aria-hidden='true'
      role='img'
      xmlns='http://www.w3.org/2000/svg'
      width='40'
      height='40'
      viewBox='0 0 40 40'
      version='1.1'
    >
      <path d='M 38.894531 7.65625 L 32.339844 1.101562 C 31.636719 0.398438 30.683594 0 29.691406 0 L 13.75 0 C 11.679688 0.0078125 10 1.6875 10 3.757812 L 10 10 L 13.75 10 L 13.75 3.757812 L 26.246094 3.757812 L 26.246094 11.878906 C 26.246094 12.917969 27.082031 13.753906 28.121094 13.753906 L 36.25 13.753906 L 36.25 36.25 L 17.5 36.25 L 17.5 40 L 36.246094 40 C 38.316406 40 40 38.320312 40 36.25 L 40 10.308594 C 40 9.320312 39.597656 8.359375 38.894531 7.65625 Z M 29.996094 10.003906 L 29.996094 4.0625 L 35.941406 10.003906 Z M 19.328125 26.429688 C 19.90625 25.839844 20.132812 24.984375 19.921875 24.179688 C 19.496094 22.566406 19.496094 22.792969 19.921875 21.175781 C 20.132812 20.375 19.90625 19.515625 19.328125 18.929688 C 18.167969 17.746094 18.28125 17.941406 17.855469 16.328125 C 17.644531 15.523438 17.027344 14.898438 16.238281 14.683594 C 14.652344 14.25 14.84375 14.363281 13.683594 13.183594 C 13.105469 12.59375 12.261719 12.363281 11.472656 12.578125 C 9.886719 13.011719 10.109375 13.011719 8.523438 12.578125 C 7.734375 12.363281 6.894531 12.59375 6.316406 13.183594 C 5.148438 14.367188 5.339844 14.253906 3.761719 14.683594 C 2.972656 14.898438 2.355469 15.527344 2.144531 16.328125 C 1.714844 17.949219 1.832031 17.746094 0.667969 18.929688 C 0.0898438 19.515625 -0.136719 20.375 0.078125 21.175781 C 0.503906 22.796875 0.5 22.566406 0.078125 24.179688 C -0.136719 24.984375 0.0898438 25.839844 0.667969 26.429688 C 1.828125 27.609375 1.71875 27.414062 2.144531 29.027344 C 2.355469 29.832031 2.972656 30.457031 3.761719 30.671875 C 4.878906 30.976562 4.660156 30.90625 5 31.0625 L 5 40 L 10 37.5 L 15 40 L 15 31.0625 C 15.335938 30.90625 15.117188 30.976562 16.234375 30.671875 C 17.027344 30.457031 17.640625 29.832031 17.855469 29.027344 C 18.28125 27.40625 18.167969 27.609375 19.328125 26.429688 Z M 10 27.5 C 7.238281 27.5 5 25.261719 5 22.5 C 5 19.738281 7.238281 17.5 10 17.5 C 12.761719 17.5 15 19.738281 15 22.5 C 15 25.261719 12.761719 27.5 10 27.5 Z M 10 27.5 ' />
    </svg>
  );
}

export function StickyNavBrandIcon() {
  return (
    <svg
      aria-hidden='true'
      role='img'
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      version='1.1'
    >
      <path d='M 14.75 13.75 L 14.5 13.75 L 14.5 12 C 14.5 11.585938 14.164062 11.25 13.75 11.25 L 13.25 11.25 L 13.25 6.5 L 11.75 6.5 L 11.75 11.25 L 10.25 11.25 L 10.25 6.5 L 8.75 6.5 L 8.75 11.25 L 7.25 11.25 L 7.25 6.5 L 5.75 6.5 L 5.75 11.25 L 4.25 11.25 L 4.25 6.5 L 2.75 6.5 L 2.75 11.25 L 2.25 11.25 C 1.835938 11.25 1.5 11.585938 1.5 12 L 1.5 13.75 L 1.25 13.75 C 0.835938 13.75 0.5 14.085938 0.5 14.5 L 0.5 15 C 0.5 15.136719 0.613281 15.25 0.75 15.25 L 15.25 15.25 C 15.386719 15.25 15.5 15.136719 15.5 15 L 15.5 14.5 C 15.5 14.085938 15.164062 13.75 14.75 13.75 Z M 13 13.75 L 3 13.75 L 3 12.75 L 13 12.75 Z M 15.257812 3.65625 L 8.472656 0.828125 C 8.167969 0.722656 7.832031 0.722656 7.527344 0.828125 L 0.742188 3.65625 C 0.597656 3.714844 0.5 3.851562 0.5 4.007812 L 0.5 4.875 C 0.5 5.082031 0.667969 5.25 0.875 5.25 L 1.5 5.25 L 1.5 5.625 C 1.5 5.832031 1.667969 6 1.875 6 L 14.125 6 C 14.332031 6 14.5 5.832031 14.5 5.625 L 14.5 5.25 L 15.125 5.25 C 15.332031 5.25 15.5 5.082031 15.5 4.875 L 15.5 4.007812 C 15.5 3.851562 15.402344 3.714844 15.257812 3.65625 Z M 2 4.5 L 8 2.25 L 14 4.5 Z M 2 4.5 ' />
    </svg>
  );
}

export function StickyNavBrandSolidIcon() {
  return (
    <svg
      aria-hidden='true'
      role='img'
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      version='1.1'
    >
      <path d='M 15.5 4 L 15.5 4.5 C 15.5 4.636719 15.386719 4.75 15.25 4.75 L 14.5 4.75 L 14.5 5.125 C 14.5 5.332031 14.332031 5.5 14.125 5.5 L 1.875 5.5 C 1.667969 5.5 1.5 5.332031 1.5 5.125 L 1.5 4.75 L 0.75 4.75 C 0.613281 4.75 0.5 4.636719 0.5 4.5 L 0.5 4 C 0.5 3.898438 0.5625 3.808594 0.65625 3.769531 L 7.90625 1.019531 C 7.964844 0.992188 8.035156 0.992188 8.09375 1.019531 L 15.34375 3.769531 C 15.4375 3.808594 15.5 3.898438 15.5 4 Z M 14.75 13.5 L 1.25 13.5 C 0.835938 13.5 0.5 13.835938 0.5 14.25 L 0.5 14.75 C 0.5 14.886719 0.613281 15 0.75 15 L 15.25 15 C 15.386719 15 15.5 14.886719 15.5 14.75 L 15.5 14.25 C 15.5 13.835938 15.164062 13.5 14.75 13.5 Z M 3 6 L 3 12 L 1.875 12 C 1.667969 12 1.5 12.167969 1.5 12.375 L 1.5 13 L 14.5 13 L 14.5 12.375 C 14.5 12.167969 14.332031 12 14.125 12 L 13 12 L 13 6 L 11 6 L 11 12 L 9 12 L 9 6 L 7 6 L 7 12 L 5 12 L 5 6 Z M 3 6 ' />
    </svg>
  );
}

export function StickyNavCampusesIcon() {
  return (
    <svg
      aria-hidden='true'
      role='img'
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      version='1.1'
    >
      <path d='M 11.222656 4.058594 L 6.566406 6.121094 C 6.34375 6.21875 6.160156 6.394531 6.058594 6.613281 L 3.929688 11.125 C 3.683594 11.644531 4.238281 12.179688 4.777344 11.941406 L 9.433594 9.878906 C 9.65625 9.78125 9.839844 9.605469 9.941406 9.386719 L 12.070312 4.875 C 12.316406 4.355469 11.761719 3.820312 11.222656 4.058594 Z M 8.726562 8.707031 C 8.324219 9.09375 7.675781 9.09375 7.273438 8.707031 C 6.871094 8.316406 6.871094 7.683594 7.273438 7.292969 C 7.675781 6.90625 8.324219 6.90625 8.726562 7.292969 C 9.128906 7.683594 9.128906 8.316406 8.726562 8.707031 Z M 8 0.25 C 3.582031 0.25 0 3.71875 0 8 C 0 12.28125 3.582031 15.75 8 15.75 C 12.417969 15.75 16 12.28125 16 8 C 16 3.71875 12.417969 0.25 8 0.25 Z M 8 14.25 C 4.441406 14.25 1.546875 11.445312 1.546875 8 C 1.546875 4.554688 4.441406 1.75 8 1.75 C 11.558594 1.75 14.453125 4.554688 14.453125 8 C 14.453125 11.445312 11.558594 14.25 8 14.25 Z M 8 14.25 ' />
    </svg>
  );
}

export function StickyNavCampusesSolidIcon() {
  return (
    <svg
      aria-hidden='true'
      role='img'
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      version='1.1'
    >
      <path d='M 7.269531 7.292969 C 6.867188 7.683594 6.867188 8.316406 7.269531 8.707031 C 7.671875 9.097656 8.328125 9.097656 8.730469 8.707031 C 9.132812 8.316406 9.132812 7.683594 8.730469 7.292969 C 8.328125 6.902344 7.671875 6.902344 7.269531 7.292969 Z M 8 0.25 C 3.582031 0.25 0 3.71875 0 8 C 0 12.28125 3.582031 15.75 8 15.75 C 12.417969 15.75 16 12.28125 16 8 C 16 3.71875 12.417969 0.25 8 0.25 Z M 12.070312 4.875 L 9.941406 9.386719 C 9.839844 9.605469 9.65625 9.78125 9.433594 9.878906 L 4.777344 11.941406 C 4.238281 12.179688 3.683594 11.644531 3.929688 11.125 L 6.058594 6.613281 C 6.164062 6.394531 6.34375 6.21875 6.566406 6.121094 L 11.222656 4.058594 C 11.761719 3.820312 12.316406 4.355469 12.070312 4.875 Z M 12.070312 4.875 ' />
    </svg>
  );
}

export function StickyNavCostsAndEntryRequirementsIcon() {
  return (
    <svg
      aria-hidden='true'
      role='img'
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      version='1.1'
    >
      <path d='M 9.386719 7.625 L 7.066406 6.941406 C 6.773438 6.851562 6.574219 6.5625 6.574219 6.230469 C 6.574219 5.828125 6.871094 5.5 7.234375 5.5 L 8.6875 5.5 C 8.914062 5.5 9.132812 5.558594 9.328125 5.667969 C 9.535156 5.785156 9.789062 5.773438 9.964844 5.617188 L 10.351562 5.265625 C 10.597656 5.039062 10.554688 4.660156 10.277344 4.476562 C 9.832031 4.1875 9.3125 4.023438 8.78125 4.007812 L 8.78125 3.5 C 8.78125 3.226562 8.546875 3 8.265625 3 L 7.75 3 C 7.464844 3 7.230469 3.226562 7.230469 3.5 L 7.230469 4 C 6.019531 4.003906 5.03125 5.003906 5.03125 6.230469 C 5.03125 7.214844 5.683594 8.097656 6.621094 8.375 L 8.941406 9.058594 C 9.230469 9.148438 9.433594 9.4375 9.433594 9.769531 C 9.433594 10.171875 9.136719 10.5 8.769531 10.5 L 7.320312 10.5 C 7.09375 10.5 6.875 10.441406 6.675781 10.332031 C 6.472656 10.214844 6.214844 10.226562 6.042969 10.382812 L 5.65625 10.734375 C 5.410156 10.960938 5.453125 11.339844 5.730469 11.523438 C 6.175781 11.8125 6.695312 11.976562 7.226562 11.992188 L 7.226562 12.5 C 7.226562 12.773438 7.457031 13 7.742188 13 L 8.257812 13 C 8.542969 13 8.773438 12.773438 8.773438 12.5 L 8.773438 12 C 9.988281 11.996094 10.972656 10.996094 10.972656 9.769531 C 10.972656 8.785156 10.324219 7.902344 9.386719 7.625 Z M 8 0.25 C 3.582031 0.25 0 3.71875 0 8 C 0 12.28125 3.582031 15.75 8 15.75 C 12.417969 15.75 16 12.28125 16 8 C 16 3.71875 12.417969 0.25 8 0.25 Z M 8 14.25 C 4.441406 14.25 1.546875 11.445312 1.546875 8 C 1.546875 4.554688 4.441406 1.75 8 1.75 C 11.558594 1.75 14.453125 4.554688 14.453125 8 C 14.453125 11.445312 11.558594 14.25 8 14.25 Z M 8 14.25 ' />
    </svg>
  );
}

export function StickyNavCostsAndEntryRequirementsSolidIcon() {
  return (
    <svg
      aria-hidden='true'
      role='img'
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      version='1.1'
    >
      <path d='M 8 0.25 C 3.582031 0.25 0 3.71875 0 8 C 0 12.28125 3.582031 15.75 8 15.75 C 12.417969 15.75 16 12.28125 16 8 C 16 3.71875 12.417969 0.25 8 0.25 Z M 8.773438 12 L 8.773438 12.5 C 8.773438 12.773438 8.542969 13 8.257812 13 L 7.742188 13 C 7.457031 13 7.226562 12.773438 7.226562 12.5 L 7.226562 11.992188 C 6.695312 11.976562 6.175781 11.8125 5.730469 11.523438 C 5.449219 11.335938 5.40625 10.957031 5.65625 10.734375 L 6.042969 10.382812 C 6.214844 10.222656 6.472656 10.210938 6.675781 10.332031 C 6.875 10.445312 7.09375 10.5 7.320312 10.5 L 8.769531 10.5 C 9.136719 10.5 9.433594 10.171875 9.433594 9.769531 C 9.433594 9.4375 9.230469 9.148438 8.941406 9.058594 L 6.613281 8.375 C 5.675781 8.101562 5.027344 7.21875 5.027344 6.230469 C 5.027344 5.003906 6.011719 4.003906 7.226562 4 L 7.226562 3.5 C 7.226562 3.226562 7.457031 3 7.742188 3 L 8.257812 3 C 8.542969 3 8.773438 3.226562 8.773438 3.5 L 8.773438 4.007812 C 9.304688 4.023438 9.824219 4.1875 10.269531 4.476562 C 10.550781 4.664062 10.59375 5.042969 10.34375 5.265625 L 9.957031 5.617188 C 9.785156 5.777344 9.527344 5.789062 9.324219 5.667969 C 9.125 5.554688 8.90625 5.5 8.679688 5.5 L 7.230469 5.5 C 6.863281 5.5 6.566406 5.828125 6.566406 6.230469 C 6.566406 6.5625 6.769531 6.851562 7.058594 6.941406 L 9.378906 7.625 C 10.316406 7.898438 10.96875 8.78125 10.96875 9.769531 C 10.972656 10.996094 9.988281 11.992188 8.773438 12 Z M 8.773438 12 ' />
    </svg>
  );
}

export function StickyNavCareersIcon() {
  return (
    <svg
      aria-hidden='true'
      role='img'
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='13'
      viewBox='0 0 16 13'
      version='1.1'
    >
      <path d='M 15.167969 3.753906 L 8.71875 1.734375 C 8.246094 1.589844 7.753906 1.589844 7.28125 1.734375 L 0.832031 3.753906 C 0.335938 3.910156 0 4.363281 0 4.875 C 0 5.390625 0.335938 5.839844 0.832031 5.996094 L 1.398438 6.171875 C 1.335938 6.304688 1.289062 6.441406 1.253906 6.585938 C 0.988281 6.71875 0.800781 6.992188 0.800781 7.3125 C 0.800781 7.585938 0.941406 7.816406 1.148438 7.964844 L 0.507812 10.878906 C 0.453125 11.132812 0.644531 11.375 0.898438 11.375 L 2.300781 11.375 C 2.558594 11.375 2.746094 11.132812 2.691406 10.878906 L 2.054688 7.964844 C 2.257812 7.816406 2.398438 7.585938 2.398438 7.3125 C 2.398438 7.042969 2.261719 6.816406 2.0625 6.667969 C 2.09375 6.578125 2.136719 6.5 2.183594 6.417969 L 3.558594 6.847656 L 3.199219 9.75 C 3.199219 10.648438 5.347656 11.375 8 11.375 C 10.652344 11.375 12.800781 10.648438 12.800781 9.75 L 12.441406 6.847656 L 15.167969 5.996094 C 15.664062 5.839844 16 5.390625 16 4.875 C 16 4.359375 15.664062 3.910156 15.167969 3.753906 Z M 11.5625 9.507812 C 10.070312 10.375 5.914062 10.367188 4.4375 9.507812 L 4.722656 7.214844 L 7.28125 8.015625 C 7.5625 8.101562 8.089844 8.214844 8.71875 8.015625 L 11.277344 7.214844 Z M 8.363281 6.851562 C 8.128906 6.925781 7.871094 6.925781 7.636719 6.851562 L 3.867188 5.667969 L 8.074219 4.867188 C 8.289062 4.828125 8.433594 4.613281 8.394531 4.394531 C 8.351562 4.171875 8.140625 4.03125 7.925781 4.070312 L 2.832031 5.039062 C 2.664062 5.070312 2.511719 5.128906 2.363281 5.199219 L 1.328125 4.875 L 7.636719 2.898438 C 7.871094 2.824219 8.128906 2.824219 8.363281 2.898438 L 14.671875 4.875 Z M 8.363281 6.851562 ' />
    </svg>
  );
}

export function StickyNavCareersSolidIcon() {
  return (
    <svg
      aria-hidden='true'
      role='img'
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='13'
      viewBox='0 0 16 13'
      version='1.1'
    >
      <path d='M 15.558594 3.890625 L 8.585938 1.714844 C 8.203125 1.59375 7.796875 1.59375 7.414062 1.714844 L 0.441406 3.890625 C -0.148438 4.074219 -0.148438 4.863281 0.441406 5.046875 L 1.65625 5.425781 C 1.390625 5.761719 1.226562 6.171875 1.210938 6.617188 C 0.96875 6.757812 0.800781 7.011719 0.800781 7.3125 C 0.800781 7.585938 0.941406 7.816406 1.148438 7.964844 L 0.507812 10.878906 C 0.453125 11.132812 0.644531 11.375 0.898438 11.375 L 2.300781 11.375 C 2.558594 11.375 2.746094 11.132812 2.691406 10.878906 L 2.054688 7.964844 C 2.257812 7.816406 2.398438 7.585938 2.398438 7.3125 C 2.398438 7.019531 2.238281 6.773438 2.007812 6.628906 C 2.027344 6.25 2.21875 5.910156 2.527344 5.699219 L 7.414062 7.222656 C 7.640625 7.292969 8.074219 7.382812 8.585938 7.222656 L 15.558594 5.046875 C 16.148438 4.863281 16.148438 4.074219 15.558594 3.890625 Z M 8.820312 8 C 8.105469 8.222656 7.5 8.101562 7.179688 8 L 3.554688 6.871094 L 3.199219 9.75 C 3.199219 10.648438 5.347656 11.375 8 11.375 C 10.652344 11.375 12.800781 10.648438 12.800781 9.75 L 12.445312 6.867188 Z M 8.820312 8 ' />
    </svg>
  );
}

export function StickyNavStudyProgramsIcon() {
  return (
    <svg
      aria-hidden='true'
      role='img'
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='18'
      viewBox='0 0 16 18'
      version='1.1'
    >
      <path d='M 15.570312 5.625 C 15.808594 5.625 16 5.433594 16 5.203125 L 16 3.796875 C 16 3.566406 15.808594 3.375 15.570312 3.375 L 14.855469 3.375 L 14.855469 1.6875 C 14.855469 0.757812 14.089844 0 13.144531 0 L 1.714844 0 C 0.769531 0 0 0.757812 0 1.6875 L 0 16.3125 C 0 17.242188 0.769531 18 1.714844 18 L 13.144531 18 C 14.089844 18 14.855469 17.242188 14.855469 16.3125 L 14.855469 14.625 L 15.570312 14.625 C 15.808594 14.625 16 14.433594 16 14.203125 L 16 12.796875 C 16 12.566406 15.808594 12.375 15.570312 12.375 L 14.855469 12.375 L 14.855469 10.125 L 15.570312 10.125 C 15.808594 10.125 16 9.933594 16 9.703125 L 16 8.296875 C 16 8.066406 15.808594 7.875 15.570312 7.875 L 14.855469 7.875 L 14.855469 5.625 Z M 13.144531 16.3125 L 1.714844 16.3125 L 1.714844 1.6875 L 13.144531 1.6875 Z M 7.429688 9 C 8.6875 9 9.714844 7.992188 9.714844 6.75 C 9.714844 5.507812 8.6875 4.5 7.429688 4.5 C 6.167969 4.5 5.144531 5.507812 5.144531 6.75 C 5.144531 7.992188 6.167969 9 7.429688 9 Z M 4.230469 13.5 L 10.628906 13.5 C 11.070312 13.5 11.429688 13.199219 11.429688 12.824219 L 11.429688 12.148438 C 11.429688 11.03125 10.355469 10.125 9.027344 10.125 C 8.644531 10.125 8.359375 10.40625 7.429688 10.40625 C 6.46875 10.40625 6.234375 10.125 5.828125 10.125 C 4.503906 10.125 3.429688 11.03125 3.429688 12.148438 L 3.429688 12.824219 C 3.429688 13.199219 3.785156 13.5 4.230469 13.5 Z M 4.230469 13.5 ' />
    </svg>
  );
}

export function StickyNavStudyProgramsSolidIcon() {
  return (
    <svg
      aria-hidden='true'
      role='img'
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='18'
      viewBox='0 0 16 18'
      version='1.1'
    >
      <path d='M 15.570312 5.625 C 15.808594 5.625 16 5.433594 16 5.203125 L 16 3.796875 C 16 3.566406 15.808594 3.375 15.570312 3.375 L 14.855469 3.375 L 14.855469 1.6875 C 14.855469 0.757812 14.089844 0 13.144531 0 L 1.714844 0 C 0.769531 0 0 0.757812 0 1.6875 L 0 16.3125 C 0 17.242188 0.769531 18 1.714844 18 L 13.144531 18 C 14.089844 18 14.855469 17.242188 14.855469 16.3125 L 14.855469 14.625 L 15.570312 14.625 C 15.808594 14.625 16 14.433594 16 14.203125 L 16 12.796875 C 16 12.566406 15.808594 12.375 15.570312 12.375 L 14.855469 12.375 L 14.855469 10.125 L 15.570312 10.125 C 15.808594 10.125 16 9.933594 16 9.703125 L 16 8.296875 C 16 8.066406 15.808594 7.875 15.570312 7.875 L 14.855469 7.875 L 14.855469 5.625 Z M 7.429688 4.5 C 8.6875 4.5 9.714844 5.507812 9.714844 6.75 C 9.714844 7.992188 8.6875 9 7.429688 9 C 6.167969 9 5.144531 7.992188 5.144531 6.75 C 5.144531 5.507812 6.167969 4.5 7.429688 4.5 Z M 11.429688 12.824219 C 11.429688 13.199219 11.070312 13.5 10.628906 13.5 L 4.230469 13.5 C 3.785156 13.5 3.429688 13.199219 3.429688 12.824219 L 3.429688 12.148438 C 3.429688 11.03125 4.503906 10.125 5.828125 10.125 L 6.007812 10.125 C 6.445312 10.304688 6.925781 10.40625 7.429688 10.40625 C 7.933594 10.40625 8.414062 10.304688 8.851562 10.125 L 9.027344 10.125 C 10.355469 10.125 11.429688 11.03125 11.429688 12.148438 Z M 11.429688 12.824219 ' />
    </svg>
  );
}

export function StickyNavAccommodationIcon() {
  return (
    <svg
      aria-hidden='true'
      role='img'
      xmlns='http://www.w3.org/2000/svg'
      width='15'
      height='14'
      viewBox='0 0 15 14'
      version='1.1'
    >
      <path d='M 14.582031 1.3125 C 14.8125 1.3125 15 1.117188 15 0.875 L 15 0.4375 C 15 0.195312 14.8125 0 14.582031 0 L 0.417969 0 C 0.1875 0 0 0.195312 0 0.4375 L 0 0.875 C 0 1.117188 0.1875 1.3125 0.417969 1.3125 L 0.832031 1.3125 L 0.832031 12.6875 L 0.417969 12.6875 C 0.1875 12.6875 0 12.882812 0 13.125 L 0 13.5625 C 0 13.804688 0.1875 14 0.417969 14 L 14.582031 14 C 14.8125 14 15 13.804688 15 13.5625 L 15 13.125 C 15 12.882812 14.8125 12.6875 14.582031 12.6875 L 14.167969 12.6875 L 14.167969 1.3125 Z M 12.917969 12.6875 L 8.332031 12.6875 L 8.332031 10.5 L 10 10.5 C 10 9.050781 8.878906 7.875 7.5 7.875 C 6.121094 7.875 5 9.050781 5 10.5 L 6.667969 10.5 L 6.667969 12.6875 L 2.082031 12.6875 L 2.082031 1.3125 L 12.917969 1.3125 Z M 7 4.375 L 8 4.375 C 8.167969 4.375 8.332031 4.199219 8.332031 4.023438 L 8.332031 2.976562 C 8.332031 2.800781 8.167969 2.625 8 2.625 L 7 2.625 C 6.832031 2.625 6.667969 2.800781 6.667969 2.976562 L 6.667969 4.023438 C 6.667969 4.199219 6.832031 4.375 7 4.375 Z M 7 7 L 8 7 C 8.167969 7 8.332031 6.824219 8.332031 6.648438 L 8.332031 5.601562 C 8.332031 5.425781 8.167969 5.25 8 5.25 L 7 5.25 C 6.832031 5.25 6.667969 5.425781 6.667969 5.601562 L 6.667969 6.648438 C 6.667969 6.824219 6.832031 7 7 7 Z M 10.332031 7 L 11.332031 7 C 11.5 7 11.667969 6.824219 11.667969 6.648438 L 11.667969 5.601562 C 11.667969 5.425781 11.5 5.25 11.332031 5.25 L 10.332031 5.25 C 10.167969 5.25 10 5.425781 10 5.601562 L 10 6.648438 C 10 6.824219 10.167969 7 10.332031 7 Z M 10.332031 4.375 L 11.332031 4.375 C 11.5 4.375 11.667969 4.199219 11.667969 4.023438 L 11.667969 2.976562 C 11.667969 2.800781 11.5 2.625 11.332031 2.625 L 10.332031 2.625 C 10.167969 2.625 10 2.800781 10 2.976562 L 10 4.023438 C 10 4.199219 10.167969 4.375 10.332031 4.375 Z M 3.667969 7 L 4.667969 7 C 4.832031 7 5 6.824219 5 6.648438 L 5 5.601562 C 5 5.425781 4.832031 5.25 4.667969 5.25 L 3.667969 5.25 C 3.5 5.25 3.332031 5.425781 3.332031 5.601562 L 3.332031 6.648438 C 3.332031 6.824219 3.5 7 3.667969 7 Z M 3.667969 4.375 L 4.667969 4.375 C 4.832031 4.375 5 4.199219 5 4.023438 L 5 2.976562 C 5 2.800781 4.832031 2.625 4.667969 2.625 L 3.667969 2.625 C 3.5 2.625 3.332031 2.800781 3.332031 2.976562 L 3.332031 4.023438 C 3.332031 4.199219 3.5 4.375 3.667969 4.375 Z M 3.667969 4.375 ' />
    </svg>
  );
}

export function StickyNavAccommodationSolidIcon() {
  return (
    <svg
      aria-hidden='true'
      role='img'
      xmlns='http://www.w3.org/2000/svg'
      width='15'
      height='14'
      viewBox='0 0 15 14'
      version='1.1'
    >
      <path d='M 14.582031 1.75 C 14.8125 1.75 15 1.554688 15 1.3125 L 15 0.4375 C 15 0.195312 14.8125 0 14.582031 0 L 0.417969 0 C 0.1875 0 0 0.195312 0 0.4375 L 0 1.3125 C 0 1.554688 0.1875 1.75 0.417969 1.75 L 0.832031 1.75 L 0.832031 12.25 L 0.417969 12.25 C 0.1875 12.25 0 12.445312 0 12.6875 L 0 13.5625 C 0 13.804688 0.1875 14 0.417969 14 L 6.667969 14 L 6.667969 11.8125 C 6.667969 11.570312 6.855469 11.375 7.082031 11.375 L 7.917969 11.375 C 8.144531 11.375 8.332031 11.570312 8.332031 11.8125 L 8.332031 14 L 14.582031 14 C 14.8125 14 15 13.804688 15 13.5625 L 15 12.6875 C 15 12.445312 14.8125 12.25 14.582031 12.25 L 14.167969 12.25 L 14.167969 1.75 Z M 6.667969 2.976562 C 6.667969 2.800781 6.832031 2.625 7 2.625 L 8 2.625 C 8.167969 2.625 8.332031 2.800781 8.332031 2.976562 L 8.332031 4.023438 C 8.332031 4.199219 8.167969 4.375 8 4.375 L 7 4.375 C 6.832031 4.375 6.667969 4.199219 6.667969 4.023438 Z M 6.667969 5.601562 C 6.667969 5.425781 6.832031 5.25 7 5.25 L 8 5.25 C 8.167969 5.25 8.332031 5.425781 8.332031 5.601562 L 8.332031 6.648438 C 8.332031 6.824219 8.167969 7 8 7 L 7 7 C 6.832031 7 6.667969 6.824219 6.667969 6.648438 Z M 3.332031 2.976562 C 3.332031 2.800781 3.5 2.625 3.667969 2.625 L 4.667969 2.625 C 4.832031 2.625 5 2.800781 5 2.976562 L 5 4.023438 C 5 4.199219 4.832031 4.375 4.667969 4.375 L 3.667969 4.375 C 3.5 4.375 3.332031 4.199219 3.332031 4.023438 Z M 4.667969 7 L 3.667969 7 C 3.5 7 3.332031 6.824219 3.332031 6.648438 L 3.332031 5.601562 C 3.332031 5.425781 3.5 5.25 3.667969 5.25 L 4.667969 5.25 C 4.832031 5.25 5 5.425781 5 5.601562 L 5 6.648438 C 5 6.824219 4.832031 7 4.667969 7 Z M 5 10.5 C 5 9.050781 6.121094 7.875 7.5 7.875 C 8.878906 7.875 10 9.050781 10 10.5 Z M 11.667969 6.648438 C 11.667969 6.824219 11.5 7 11.332031 7 L 10.332031 7 C 10.167969 7 10 6.824219 10 6.648438 L 10 5.601562 C 10 5.425781 10.167969 5.25 10.332031 5.25 L 11.332031 5.25 C 11.5 5.25 11.667969 5.425781 11.667969 5.601562 Z M 11.667969 4.023438 C 11.667969 4.199219 11.5 4.375 11.332031 4.375 L 10.332031 4.375 C 10.167969 4.375 10 4.199219 10 4.023438 L 10 2.976562 C 10 2.800781 10.167969 2.625 10.332031 2.625 L 11.332031 2.625 C 11.5 2.625 11.667969 2.800781 11.667969 2.976562 Z M 11.667969 4.023438 ' />
    </svg>
  );
}

export function StickyNavServicesAndFacilitiesIcon() {
  return (
    <svg
      aria-hidden='true'
      role='img'
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      version='1.1'
    >
      <path d='M 15.5 12.5 L 15 12.5 L 15 11 C 15 7.472656 12.390625 4.566406 9 4.078125 L 9 3.5 L 10.5 3.5 C 10.777344 3.5 11 3.277344 11 3 L 11 2.5 C 11 2.222656 10.777344 2 10.5 2 L 5.5 2 C 5.222656 2 5 2.222656 5 2.5 L 5 3 C 5 3.277344 5.222656 3.5 5.5 3.5 L 7 3.5 L 7 4.078125 C 3.609375 4.566406 1 7.472656 1 11 L 1 12.5 L 0.5 12.5 C 0.222656 12.5 0 12.722656 0 13 L 0 13.5 C 0 13.777344 0.222656 14 0.5 14 L 15.5 14 C 15.777344 14 16 13.777344 16 13.5 L 16 13 C 16 12.722656 15.777344 12.5 15.5 12.5 Z M 13.5 12.5 L 2.5 12.5 L 2.5 11 C 2.5 7.96875 4.96875 5.5 8 5.5 C 11.03125 5.5 13.5 7.96875 13.5 11 Z M 13.5 12.5 ' />
    </svg>
  );
}

export function StickyNavServicesAndFacilitiesSolidIcon() {
  return (
    <svg
      aria-hidden='true'
      role='img'
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      version='1.1'
    >
      <path d='M 9 4.078125 L 9 3.5 L 9.5 3.5 C 9.777344 3.5 10 3.277344 10 3 L 10 2.5 C 10 2.222656 9.777344 2 9.5 2 L 6.5 2 C 6.222656 2 6 2.222656 6 2.5 L 6 3 C 6 3.277344 6.222656 3.5 6.5 3.5 L 7 3.5 L 7 4.078125 C 3.609375 4.566406 1 7.472656 1 11 L 15 11 C 15 7.472656 12.390625 4.566406 9 4.078125 Z M 15.5 12 L 0.5 12 C 0.222656 12 0 12.222656 0 12.5 L 0 13.5 C 0 13.777344 0.222656 14 0.5 14 L 15.5 14 C 15.777344 14 16 13.777344 16 13.5 L 16 12.5 C 16 12.222656 15.777344 12 15.5 12 Z M 15.5 12 ' />
    </svg>
  );
}

export function StickyNavMediaGalleryIcon() {
  return (
    <svg
      aria-hidden='true'
      role='img'
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='13'
      viewBox='0 0 16 13'
      version='1.1'
    >
      <path d='M 15.199219 0 L 4 0 C 3.558594 0 3.199219 0.332031 3.199219 0.746094 L 3.199219 2.84375 L 4.398438 2.84375 L 4.398438 1.21875 L 5.601562 1.21875 L 5.601562 2.84375 L 6.800781 2.84375 L 6.800781 1.21875 L 12.398438 1.21875 L 12.398438 8.9375 L 15.199219 8.9375 C 15.640625 8.9375 16 8.605469 16 8.191406 L 16 0.746094 C 16 0.332031 15.640625 0 15.199219 0 Z M 14.800781 7.71875 L 13.601562 7.71875 L 13.601562 6.296875 L 14.800781 6.296875 Z M 14.800781 5.078125 L 13.601562 5.078125 L 13.601562 3.859375 L 14.800781 3.859375 Z M 14.800781 2.640625 L 13.601562 2.640625 L 13.601562 1.21875 L 14.800781 1.21875 Z M 3.199219 8.125 C 3.640625 8.125 4 7.761719 4 7.3125 C 4 6.863281 3.640625 6.5 3.199219 6.5 C 2.757812 6.5 2.398438 6.863281 2.398438 7.3125 C 2.398438 7.761719 2.757812 8.125 3.199219 8.125 Z M 10.398438 4.0625 L 0.800781 4.0625 C 0.359375 4.0625 0 4.425781 0 4.875 L 0 12.1875 C 0 12.636719 0.359375 13 0.800781 13 L 10.398438 13 C 10.84375 13 11.199219 12.636719 11.199219 12.1875 L 11.199219 4.875 C 11.199219 4.425781 10.84375 4.0625 10.398438 4.0625 Z M 10 10.15625 L 7.484375 7.601562 C 7.328125 7.441406 7.074219 7.441406 6.917969 7.601562 L 4.398438 10.15625 L 3.484375 9.226562 C 3.328125 9.066406 3.074219 9.066406 2.917969 9.226562 L 1.199219 10.96875 L 1.199219 5.28125 L 10 5.28125 Z M 10 10.15625 ' />
    </svg>
  );
}

export function StickyNavMediaGallerySolidIcon() {
  return (
    <svg
      aria-hidden='true'
      role='img'
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='13'
      viewBox='0 0 16 13'
      version='1.1'
    >
      <path d='M 15.199219 0 L 4 0 C 3.558594 0 3.199219 0.363281 3.199219 0.8125 L 3.199219 3.25 L 7.199219 3.25 L 7.199219 1.625 L 12 1.625 L 12 9.75 L 15.199219 9.75 C 15.640625 9.75 16 9.386719 16 8.9375 L 16 0.8125 C 16 0.363281 15.640625 0 15.199219 0 Z M 5.800781 2.617188 C 5.800781 2.742188 5.699219 2.84375 5.574219 2.84375 L 4.824219 2.84375 C 4.699219 2.84375 4.601562 2.742188 4.601562 2.617188 L 4.601562 1.851562 C 4.601562 1.726562 4.699219 1.625 4.824219 1.625 L 5.574219 1.625 C 5.699219 1.625 5.800781 1.726562 5.800781 1.851562 Z M 14.601562 7.898438 C 14.601562 8.023438 14.5 8.125 14.375 8.125 L 13.625 8.125 C 13.5 8.125 13.398438 8.023438 13.398438 7.898438 L 13.398438 7.132812 C 13.398438 7.007812 13.5 6.90625 13.625 6.90625 L 14.375 6.90625 C 14.5 6.90625 14.601562 7.007812 14.601562 7.132812 Z M 14.601562 5.257812 C 14.601562 5.382812 14.5 5.484375 14.375 5.484375 L 13.625 5.484375 C 13.5 5.484375 13.398438 5.382812 13.398438 5.257812 L 13.398438 4.492188 C 13.398438 4.367188 13.5 4.265625 13.625 4.265625 L 14.375 4.265625 C 14.5 4.265625 14.601562 4.367188 14.601562 4.492188 Z M 14.601562 2.617188 C 14.601562 2.742188 14.5 2.84375 14.375 2.84375 L 13.625 2.84375 C 13.5 2.84375 13.398438 2.742188 13.398438 2.617188 L 13.398438 1.851562 C 13.398438 1.726562 13.5 1.625 13.625 1.625 L 14.375 1.625 C 14.5 1.625 14.601562 1.726562 14.601562 1.851562 Z M 10.398438 4.0625 L 0.800781 4.0625 C 0.359375 4.0625 0 4.425781 0 4.875 L 0 12.1875 C 0 12.636719 0.359375 13 0.800781 13 L 10.398438 13 C 10.84375 13 11.199219 12.636719 11.199219 12.1875 L 11.199219 4.875 C 11.199219 4.425781 10.84375 4.0625 10.398438 4.0625 Z M 2.398438 5.6875 C 2.84375 5.6875 3.199219 6.050781 3.199219 6.5 C 3.199219 6.949219 2.84375 7.3125 2.398438 7.3125 C 1.957031 7.3125 1.601562 6.949219 1.601562 6.5 C 1.601562 6.050781 1.957031 5.6875 2.398438 5.6875 Z M 9.601562 11.375 L 1.601562 11.375 L 1.601562 10.5625 L 3.199219 8.9375 L 4 9.75 L 7.199219 6.5 L 9.601562 8.9375 Z M 9.601562 11.375 ' />
    </svg>
  );
}

export function StickyNavHowToApplyIcon() {
  return (
    <svg
      aria-hidden='true'
      role='img'
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      version='1.1'
    >
      <path d='M 15.75 8 C 15.75 3.71875 12.28125 0.25 8 0.25 C 3.71875 0.25 0.25 3.71875 0.25 8 C 0.25 12.28125 3.71875 15.75 8 15.75 C 12.28125 15.75 15.75 12.28125 15.75 8 Z M 1.75 8 C 1.75 4.546875 4.546875 1.75 8 1.75 C 11.453125 1.75 14.25 4.546875 14.25 8 C 14.25 11.453125 11.453125 14.25 8 14.25 C 4.546875 14.25 1.75 11.453125 1.75 8 Z M 4 8.625 L 4 7.375 C 4 7.167969 4.167969 7 4.375 7 L 8 7 L 8 4.90625 C 8 4.570312 8.402344 4.40625 8.640625 4.640625 L 11.734375 7.734375 C 11.882812 7.882812 11.882812 8.117188 11.734375 8.265625 L 8.640625 11.359375 C 8.402344 11.597656 8 11.429688 8 11.09375 L 8 9 L 4.375 9 C 4.167969 9 4 8.832031 4 8.625 Z M 4 8.625 ' />
    </svg>
  );
}

export function StickyNavHowToApplySolidIcon() {
  return (
    <svg
      aria-hidden='true'
      role='img'
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      version='1.1'
    >
      <path d='M 8 0.25 C 12.28125 0.25 15.75 3.71875 15.75 8 C 15.75 12.28125 12.28125 15.75 8 15.75 C 3.71875 15.75 0.25 12.28125 0.25 8 C 0.25 3.71875 3.71875 0.25 8 0.25 Z M 4.375 9.375 L 8 9.375 L 8 11.589844 C 8 11.925781 8.40625 12.09375 8.640625 11.855469 L 12.210938 8.265625 C 12.359375 8.117188 12.359375 7.882812 12.210938 7.738281 L 8.640625 4.144531 C 8.402344 3.90625 8 4.074219 8 4.410156 L 8 6.625 L 4.375 6.625 C 4.167969 6.625 4 6.792969 4 7 L 4 9 C 4 9.207031 4.167969 9.375 4.375 9.375 Z M 4.375 9.375 ' />
    </svg>
  );
}

export function HowToApplyIcon() {
  return (
    <svg aria-hidden='true' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 384 512'>
      <path
        fill='currentColor'
        d='M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zM65.6 209.4l12.7-12.6c2.1-2.1 5.5-2.1 7.6 0l20.6 20.8 47.6-47.2c2.1-2.1 5.5-2.1 7.6 0l12.6 12.7c2.1 2.1 2.1 5.5 0 7.6l-64.2 63.6c-2.1 2.1-5.5 2.1-7.6 0L65.6 217c-2.1-2.1-2.1-5.5 0-7.6zM96 392c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm224-16c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-128c0 4.4-4.3 8-9.6 8H154.1l32.3-32h124c5.3 0 9.6 3.6 9.6 8v16z'
      />
    </svg>
  );
}

export function PreparingForArrivalIcon() {
  return (
    <svg aria-hidden='true' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 576 512'>
      <path
        fill='currentColor'
        d='M480 192H365.71L260.61 8.06A16.014 16.014 0 00246.71 0h-65.5c-10.63 0-18.3 10.17-15.38 20.39L214.86 192H112l-43.2-57.6c-3.02-4.03-7.77-6.4-12.8-6.4H16.01C5.6 128-2.04 137.78.49 147.88L32 256 .49 364.12C-2.04 374.22 5.6 384 16.01 384H56c5.04 0 9.78-2.37 12.8-6.4L112 320h102.86l-49.03 171.6c-2.92 10.22 4.75 20.4 15.38 20.4h65.5c5.74 0 11.04-3.08 13.89-8.06L365.71 320H480c35.35 0 96-28.65 96-64s-60.65-64-96-64z'
      />
    </svg>
  );
}

export function PostOfferProcessIcon() {
  return (
    <svg aria-hidden='true' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 384 512'>
      <path
        fill='currentColor'
        d='M360 0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V24c0-13.3-10.7-24-24-24zM128 400c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zm0-128c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zm0-128c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zm192 248c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-128c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-128c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z'
      />
    </svg>
  );
}

export function PlayCircleRegularWhiteIcon() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 496 496' fill='#ffffff'>
      <path d='M363.7,230l-176-107c-15.8-8.8-35.7,2.5-35.7,21V352c0,18.4,19.8,29.8,35.7,21l176-101C380.1,262.9,380.1,239.2,363.7,230ZM496,248C496,111,385,0,248,0S0,111,0,248,111,496,248,496,496,385,496,248ZM48,248A200,200,0,1,1,248,448,199.94,199.94,0,0,1,48,248Z' />
    </svg>
  );
}

export function SLAIcon() {
  return (
    <svg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M17.9548 42.1928L33.6541 23.5009L17.9548 4.71834C17.0526 3.62949 16.6917 2.26843 16.8721 0.998108C13.1729 2.17769 9.83455 4.26465 7.12778 6.89603L18.0451 20.0529C19.0376 21.1418 19.3985 22.2306 19.3985 23.4102C19.3985 24.4991 19.0376 25.5879 18.0451 26.7675L6.58643 40.5595C9.47364 43.5539 13.0827 45.913 17.1428 47.0926C16.5112 45.4594 16.7819 43.6446 17.9548 42.1928Z'
        fill='#E2001A'
      />
      <path
        d='M1.53383 15.5161C0.541353 18.1474 0 20.9603 0 23.9546C0 26.6767 0.451128 29.3081 1.35338 31.758L8.30075 23.5009L1.53383 15.5161Z'
        fill='#E2001A'
      />
      <path
        d='M26.7068 0L43.3083 19.9622C44.3008 21.051 44.6617 22.1399 44.6617 23.3195C44.6617 24.4083 44.3008 25.4972 43.3083 26.6767L25.7144 48C38.1655 47.0926 48.0001 36.7486 48.0001 23.9546C48.0001 11.6144 38.7068 1.36106 26.7068 0Z'
        fill='#E2001A'
      />
    </svg>
  );
}

export function InfoIcon() {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M8 0C3.58203 0 0 3.58332 0 8C0 12.4193 3.58203 16 8 16C12.418 16 16 12.4193 16 8C16 3.58332 12.418 0 8 0ZM8 14.4516C4.43445 14.4516 1.54839 11.5667 1.54839 8C1.54839 4.43564 4.43458 1.54839 8 1.54839C11.5642 1.54839 14.4516 4.43455 14.4516 8C14.4516 11.5655 11.5667 14.4516 8 14.4516ZM8 3.54839C8.74826 3.54839 9.35484 4.15497 9.35484 4.90323C9.35484 5.65148 8.74826 6.25806 8 6.25806C7.25174 6.25806 6.64516 5.65148 6.64516 4.90323C6.64516 4.15497 7.25174 3.54839 8 3.54839ZM9.80645 11.7419C9.80645 11.9557 9.63313 12.129 9.41935 12.129H6.58064C6.36687 12.129 6.19355 11.9557 6.19355 11.7419V10.9677C6.19355 10.754 6.36687 10.5806 6.58064 10.5806H6.96774V8.51613H6.58064C6.36687 8.51613 6.19355 8.34281 6.19355 8.12903V7.35484C6.19355 7.14106 6.36687 6.96774 6.58064 6.96774H8.64516C8.85894 6.96774 9.03226 7.14106 9.03226 7.35484V10.5806H9.41935C9.63313 10.5806 9.80645 10.754 9.80645 10.9677V11.7419Z'
        fill='#336B9B'
      />
    </svg>
  );
}

export function INTOWhiteLogo() {
  return (
    <svg
      width='110'
      height='28'
      viewBox='0 0 96 24'
      fill='none'
      aria-label='INTO University Partnerships'
      xmlns='http://www.w3.org/2000/svg'
      role='img'
      aria-describedby='INTOWhiteLogo INTOWhiteLogoDesc'
    >
      <title id='INTOWhiteLogo'>INTO - international student recruitment partnerships</title>
      <desc id='INTOWhiteLogoDesc'>
        INTO partnerships empower universities to recruit international students with unparalleled
        reach, control and transparency.
      </desc>
      <g clipPath='url(#clip0_245_395)'>
        <path
          d='M82.4827 24C75.862 24 70.4827 18.6207 70.4827 12C70.4827 5.37931 75.862 0 82.4827 0C89.1034 0 94.4827 5.37931 94.4827 12C94.4827 18.6207 89.1034 24 82.4827 24ZM82.4827 1.7931C76.8275 1.7931 72.2758 6.34483 72.2758 12C72.2758 17.6552 76.8275 22.2069 82.4827 22.2069C88.1378 22.2069 92.6896 17.6552 92.6896 12C92.6896 6.41379 88.1378 1.7931 82.4827 1.7931ZM83.1723 12.8276L78.6896 18.1379C78.2758 18.6207 77.5172 18.6897 76.9654 18.2759C76.4827 17.8621 76.4137 17.1034 76.8275 16.6207L80.7585 12L76.8275 7.37931C76.4137 6.89655 76.4827 6.06896 76.9654 5.65517C77.4482 5.24138 78.2758 5.31034 78.6896 5.7931L83.2413 11.1724C83.4482 11.3793 83.5861 11.7241 83.5861 12C83.5172 12.3448 83.4482 12.6207 83.1723 12.8276ZM89.4482 12.8276L84.9654 18.1379C84.5516 18.6207 83.793 18.6897 83.2413 18.2759C82.7585 17.8621 82.6896 17.1034 83.1034 16.6207L87.0344 12L83.1034 7.37931C82.6896 6.89655 82.7585 6.06896 83.2413 5.65517C83.724 5.24138 84.5516 5.31034 84.9654 5.7931L89.4482 11.1724C89.6551 11.3793 89.793 11.7241 89.793 12C89.793 12.3448 89.7241 12.6207 89.4482 12.8276Z'
          fill='white'
        />
        <path
          d='M57.4484 23.4477C52.4829 23.4477 48.207 20.896 48.207 13.5856V10.4822C48.207 3.17184 52.4139 0.620117 57.4484 0.620117C62.4829 0.620117 66.6898 3.17184 66.6898 10.5512V13.6546C66.6898 20.896 62.4139 23.4477 57.4484 23.4477ZM60.4829 10.4822C60.4829 7.24081 59.5863 5.93046 57.4484 5.93046C55.3105 5.93046 54.4139 7.24081 54.4139 10.4822V13.5856C54.4139 16.827 55.3105 18.0684 57.4484 18.0684C59.5863 18.0684 60.4829 16.758 60.4829 13.5856V10.4822Z'
          fill='white'
        />
        <path
          d='M46.7584 5.862H42.2757V22.5517C42.2757 22.8965 41.9998 23.1723 41.655 23.1723H36.7584C36.4136 23.1723 36.1377 22.8965 36.1377 22.5517V5.862H31.586C31.2412 5.862 30.9653 5.6551 30.9653 5.31028V1.44821C30.9653 1.10338 31.2412 0.896484 31.5171 0.896484H46.6205C46.9653 0.896484 47.2412 1.10338 47.2412 1.44821V5.31028C47.3791 5.6551 47.1033 5.862 46.7584 5.862Z'
          fill='white'
        />
        <path
          d='M28 23.1723H24C23.4483 23.1723 22.9656 22.8275 22.7587 22.3448L16.8276 12.3448C16.6897 12.1379 16.6207 12.1379 16.5518 12.1379C16.4828 12.1379 16.4138 12.2068 16.4138 12.4137V22.6206C16.4138 22.9655 16.138 23.2413 15.7931 23.2413H11.3104C10.9656 23.2413 10.6897 22.9655 10.6897 22.6206V1.99993C10.6897 1.37924 11.1725 0.896484 11.7931 0.896484H15.7242C16.2759 0.896484 16.6207 1.24131 16.8966 1.79304L22.9656 12.1379C23.1035 12.3448 23.1725 12.4137 23.2414 12.4137C23.3104 12.4137 23.3794 12.4137 23.3794 12.1379V1.51717C23.3794 1.17235 23.6552 0.896484 24 0.896484H28.4828C28.8276 0.896484 29.1035 1.17235 29.1035 1.51717V22.1379C29.1035 22.6896 28.6207 23.1723 28 23.1723Z'
          fill='white'
        />
        <path
          d='M5.51724 23.1723H0.62069C0.275862 23.1723 0 22.8965 0 22.5517V1.44821C0 1.10338 0.275862 0.896484 0.551724 0.896484H5.51724C5.86207 0.896484 6.13793 1.10338 6.13793 1.44821V22.5517C6.13793 22.8965 5.86207 23.1723 5.51724 23.1723Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_245_395'>
          <rect width='94.4828' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}

export function FacebookIcon() {
  return (
    <svg
      width='36'
      height='36'
      className='svg-inline--fa fa-facebook-square fa-w-14'
      aria-hidden='true'
      focusable='false'
      data-prefix='fab'
      data-icon='facebook-square'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 448 512'
      role='img'
      aria-describedby='FacebookIcon'
    >
      <title id='FacebookIcon'>Facebook Social Icon</title>
      <path
        fill='#ffffff'
        d='M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z'
      ></path>
    </svg>
  );
}

export function InstagramIcon() {
  return (
    <svg
      width='36'
      height='36'
      className='svg-inline--fa fa-instagram fa-w-14'
      aria-hidden='true'
      focusable='false'
      data-prefix='fab'
      data-icon='instagram'
      role='img'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 448 512'
      aria-describedby='InstagramIcon'
    >
      <title id='InstagramIcon'>Instagram Social Icon</title>
      <path
        fill='#ffffff'
        d='M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z'
      ></path>
    </svg>
  );
}

export function LinkedInIcon() {
  return (
    <svg
      width='36'
      height='36'
      className='svg-inline--fa fa-linkedin fa-w-14'
      aria-hidden='true'
      focusable='false'
      data-prefix='fab'
      data-icon='linkedin'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 448 512'
      aria-describedby='LinkedInIcon'
    >
      <title id='LinkedInIcon'>LinkedIn Social Icon</title>
      <path
        fill='#ffffff'
        d='M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z'
      ></path>
    </svg>
  );
}

export function TwitterIcon() {
  return (
    <svg
      width='36'
      height='36'
      className='svg-inline--fa fa-twitter-square fa-w-14'
      aria-hidden='true'
      focusable='false'
      data-prefix='fab'
      data-icon='twitter-square'
      role='img'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 448 512'
      aria-describedby='TwitterIcon'
    >
      <title id='TwitterIcon'>Twitter Social Icon</title>
      <path
        fill='#ffffff'
        d='M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-48.9 158.8c.2 2.8.2 5.7.2 8.5 0 86.7-66 186.6-186.6 186.6-37.2 0-71.7-10.8-100.7-29.4 5.3.6 10.4.8 15.8.8 30.7 0 58.9-10.4 81.4-28-28.8-.6-53-19.5-61.3-45.5 10.1 1.5 19.2 1.5 29.6-1.2-30-6.1-52.5-32.5-52.5-64.4v-.8c8.7 4.9 18.9 7.9 29.6 8.3a65.447 65.447 0 0 1-29.2-54.6c0-12.2 3.2-23.4 8.9-33.1 32.3 39.8 80.8 65.8 135.2 68.6-9.3-44.5 24-80.6 64-80.6 18.9 0 35.9 7.9 47.9 20.7 14.8-2.8 29-8.3 41.6-15.8-4.9 15.2-15.2 28-28.8 36.1 13.2-1.4 26-5.1 37.8-10.2-8.9 13.1-20.1 24.7-32.9 34z'
      ></path>
    </svg>
  );
}

export function GlobeIcon(props: IconProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 496 512'
      role='img'
      fill='none'
      width={props?.width}
      height={props?.height}
      aria-describedby='GlobeIcon'
    >
      <title id='GlobeIcon'>GlobeIcon - representing localization support</title>
      <path
        fill={props?.fillColor}
        d='M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm179.3 160h-67.2c-6.7-36.5-17.5-68.8-31.2-94.7 42.9 19 77.7 52.7 98.4 94.7zM248 56c18.6 0 48.6 41.2 63.2 112H184.8C199.4 97.2 229.4 56 248 56zM48 256c0-13.7 1.4-27.1 4-40h77.7c-1 13.1-1.7 26.3-1.7 40s.7 26.9 1.7 40H52c-2.6-12.9-4-26.3-4-40zm20.7 88h67.2c6.7 36.5 17.5 68.8 31.2 94.7-42.9-19-77.7-52.7-98.4-94.7zm67.2-176H68.7c20.7-42 55.5-75.7 98.4-94.7-13.7 25.9-24.5 58.2-31.2 94.7zM248 456c-18.6 0-48.6-41.2-63.2-112h126.5c-14.7 70.8-44.7 112-63.3 112zm70.1-160H177.9c-1.1-12.8-1.9-26-1.9-40s.8-27.2 1.9-40h140.3c1.1 12.8 1.9 26 1.9 40s-.9 27.2-2 40zm10.8 142.7c13.7-25.9 24.4-58.2 31.2-94.7h67.2c-20.7 42-55.5 75.7-98.4 94.7zM366.3 296c1-13.1 1.7-26.3 1.7-40s-.7-26.9-1.7-40H444c2.6 12.9 4 26.3 4 40s-1.4 27.1-4 40h-77.7z'
      />
    </svg>
  );
}

export function ChevronDown(props: IconProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 448 512'
      role='img'
      fill='none'
      width={props?.width}
      height={props?.height}
      aria-describedby='DownArrowIcon'
    >
      <title id='DownArrowIcon'>DownArrowIcon - representing down arrow / chevron icon</title>
      <path
        fill={props?.fillColor}
        d='M441.9 167.3l-19.8-19.8c-4.7-4.7-12.3-4.7-17 0L224 328.2 42.9 147.5c-4.7-4.7-12.3-4.7-17 0L6.1 167.3c-4.7 4.7-4.7 12.3 0 17l209.4 209.4c4.7 4.7 12.3 4.7 17 0l209.4-209.4c4.7-4.7 4.7-12.3 0-17z'
      />
    </svg>
  );
}

export function TickIcon(props: IconProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 512 512'
      role='img'
      fill='none'
      width={props?.width}
      height={props?.height}
      aria-describedby='TickIcon'
    >
      <title id='TickIcon'>TickIcon - representing check / selected / tick icon</title>
      <path
        fill={props?.fillColor}
        d='M435.8 83.5L172.8 346.5l-96.7-96.7c-4.7-4.7-12.3-4.7-17 0l-28.3 28.3c-4.7 4.7-4.7 12.3 0 17l133.4 133.4c4.7 4.7 12.3 4.7 17 0l299.8-299.8c4.7-4.7 4.7-12.3 0-17l-28.3-28.3c-4.7-4.7-12.3-4.7-17 0z'
      />
    </svg>
  );
}

export function ProfileIcon(props: IconProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 448 512'
      role='img'
      fill='none'
      width={props?.width}
      height={props?.height}
      aria-describedby='UserIcon'
    >
      <title id='UserIcon'>UserIcon - representing user / profile icon</title>
      <path
        fill={props?.fillColor}
        d='M313.6 304c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-25.6c0-74.2-60.2-134.4-134.4-134.4zM400 464H48v-25.6c0-47.6 38.8-86.4 86.4-86.4 14.6 0 38.3 16 89.6 16 51.7 0 74.9-16 89.6-16 47.6 0 86.4 38.8 86.4 86.4V464zM224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z'
      />
    </svg>
  );
}

export function SearchIcon(props: IconProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 512 512'
      role='img'
      fill='none'
      width={props?.width}
      height={props?.height}
      aria-describedby='SearchIcon'
    >
      <title id='SearchIcon'>SearchIcon - representing search icon</title>
      <path
        fill={props?.fillColor}
        d='M508.5 468.9L387.1 347.5c-2.3-2.3-5.3-3.5-8.5-3.5h-13.2c31.5-36.5 50.6-84 50.6-136C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c52 0 99.5-19.1 136-50.6v13.2c0 3.2 1.3 6.2 3.5 8.5l121.4 121.4c4.7 4.7 12.3 4.7 17 0l22.6-22.6c4.7-4.7 4.7-12.3 0-17zM208 368c-88.4 0-160-71.6-160-160S119.6 48 208 48s160 71.6 160 160-71.6 160-160 160z'
      />
    </svg>
  );
}

export function CrossIcon(props: IconProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 320 512'
      role='img'
      fill='none'
      width={props?.width}
      height={props?.height}
      aria-describedby='CrossIcon'
    >
      <title id='CrossIcon'>CrossIcon - representing close / remove icon</title>
      <path
        fill={props?.fillColor}
        d='M207.6 256l107.7-107.7c6.2-6.2 6.2-16.3 0-22.6l-25-25c-6.2-6.2-16.3-6.2-22.6 0L160 208.4 52.3 100.7c-6.2-6.2-16.3-6.2-22.6 0L4.7 125.7c-6.2 6.2-6.2 16.3 0 22.6L112.4 256 4.7 363.7c-6.2 6.2-6.2 16.3 0 22.6l25 25c6.2 6.2 16.3 6.2 22.6 0L160 303.6l107.7 107.7c6.2 6.2 16.3 6.2 22.6 0l25-25c6.2-6.2 6.2-16.3 0-22.6L207.6 256z'
      />
    </svg>
  );
}

export function HamburgerIcon(props: IconProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 448 512'
      role='img'
      fill='none'
      width={props?.width}
      height={props?.height}
      aria-describedby='HamburgerIcon'
    >
      <title id='HamburgerIcon'>HamburgerIcon - representing responsive menu trigger icon</title>
      <path
        fill={props?.fillColor}
        d='M436 124H12c-6.6 0-12-5.4-12-12V80c0-6.6 5.4-12 12-12h424c6.6 0 12 5.4 12 12v32c0 6.6-5.4 12-12 12zm0 160H12c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h424c6.6 0 12 5.4 12 12v32c0 6.6-5.4 12-12 12zm0 160H12c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h424c6.6 0 12 5.4 12 12v32c0 6.6-5.4 12-12 12z'
      />
    </svg>
  );
}